import { WindowPercentageArea } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const numberToWindowAreaDictionary: EnumDictionary<number, WindowPercentageArea> = {
    [0.1]: WindowPercentageArea.Small,
    [0.25]: WindowPercentageArea.Medium,
    [0.35]: WindowPercentageArea.Large
};
